// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"359":"c3c61967","776":"86b32fa3"}[chunkId] + ".chunk.css";
};